const EventSortableFields = {
    CREATED_AT: 'createdAt',
    RELEASE_DATE: 'releaseDate',
    FINALIZED_AT: 'finalizedAt',
    NAME: 'name',
}

export default EventSortableFields;
